module.exports = __webpack_public_path__ + "static/img/undraw_dev_productivity_umsq.ef4796e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_dev_productivity_umsq.svg
// module id = jk0R
// module chunks = 1